// this is an autogenerated file from DesignSystem/PreviewDocumentModal/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_PreviewDocumentModal_Content($resource_id: StringOrNumber!) {
  vaxiom_resource_object_meta(
    resource_id: $resource_id
    resource_type: document
  ) {
    name
    source_key
    content_type
    size
    preview_url
    url
  }
}

`